import config from '../data/resolutionTypes.json';

const FALLBACK_PALETTE = [
  '#4C6FE0',
  '#2A9FB3',
  '#E08A45',
  '#2F9E73',
  '#9B6AD6',
  '#C49A1F',
  '#D95F7F',
  '#7B8494',
];

export const BLANK_RESOLUTION_TYPE = 'BLANK';

const LEGACY_COLORS = {
  PROCEDURE: '#4C6FE0',
  DOUBT_INFORMATION: '#2A9FB3',
  CODE_FIX: '#E08A45',
  NETWORK_INFRASTRUCTURE: '#2F9E73',
  CONFIGURATION: '#9B6AD6',
  DATA_ADJUSTMENT: '#C49A1F',
  THIRD_PARTY: '#D95F7F',
  OTHER: '#7B8494',
  [BLANK_RESOLUTION_TYPE]: '#C9C9C9',
};

/** @type {Array<{ code: string, label: string, color?: string, active?: boolean, sortOrder?: number }>|null} */
let resolutionTypeRegistry = null;

const colorFromCodeHash = (code) => {
  const key = String(code).toUpperCase();
  if (LEGACY_COLORS[key]) return LEGACY_COLORS[key];
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  return FALLBACK_PALETTE[Math.abs(hash) % FALLBACK_PALETTE.length];
};

export const normalizeResolutionTypeColor = (color, code = '') => {
  if (typeof color === 'string' && /^#[0-9A-Fa-f]{6}$/.test(color.trim())) {
    return color.trim().toUpperCase();
  }
  return colorFromCodeHash(code);
};

export const setResolutionTypeRegistry = (definitions) => {
  if (!Array.isArray(definitions)) {
    resolutionTypeRegistry = null;
    return;
  }
  resolutionTypeRegistry = definitions
    .filter((d) => d?.code)
    .map((d) => ({
      code: String(d.code).toUpperCase(),
      label: d.label || d.code,
      color: normalizeResolutionTypeColor(d.color, d.code),
      active: d.active !== false,
      sortOrder: typeof d.sortOrder === 'number' ? d.sortOrder : 0,
    }))
    .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
};

export const getResolutionTypeRegistry = () => resolutionTypeRegistry;

const fallbackLabel = (code) => {
  const key = String(code).toUpperCase();
  return config.label[key] ?? String(code);
};

export const getResolutionTypeLabel = (code) => {
  if (code == null || code === '') return '';
  const key = String(code).toUpperCase();
  if (key === BLANK_RESOLUTION_TYPE) return 'Sem motivo de resolução';
  const fromApi = resolutionTypeRegistry?.find((item) => item.code === key);
  return fromApi?.label ?? fallbackLabel(key);
};

export const getResolutionTypeColor = (code) => {
  if (code == null || code === '') return '#95A5A6';
  const key = String(code).toUpperCase();
  const fromApi = resolutionTypeRegistry?.find((item) => item.code === key);
  return fromApi?.color ?? colorFromCodeHash(key);
};

export const getResolutionTypeOptions = () => {
  if (resolutionTypeRegistry?.length) {
    return resolutionTypeRegistry
      .filter((item) => item.active)
      .map((item) => ({
        value: item.code,
        label: item.label,
        color: item.color,
      }));
  }
  return Object.keys(config.label).map((key) => ({
    value: config.value[key] ?? key,
    label: config.label[key],
    color: colorFromCodeHash(key),
  }));
};

export const RESOLUTION_TYPE_OPTIONS = getResolutionTypeOptions();

export const RESOLUTION_TYPE_COLORS = LEGACY_COLORS;

export const MAX_RESOLUTION_NOTES_LENGTH = 2000;
